import { startOfDay, endOfDay, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear } from 'date-fns';
import { Period } from '../types';

export const getDateRange = (period: Period): { start: Date; end: Date } => {
  const now = new Date();
  
  switch (period) {
    case 'daily':
      return { start: startOfDay(now), end: endOfDay(now) };
    case 'weekly':
      return { start: startOfWeek(now), end: endOfWeek(now) };
    case 'monthly':
      return { start: startOfMonth(now), end: endOfMonth(now) };
    case 'yearly':
      return { start: startOfYear(now), end: endOfYear(now) };
    default:
      return { start: startOfDay(now), end: endOfDay(now) };
  }
};

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

export const calculateProfitMargin = (value: number, cost: number): number => {
  if (cost === 0) return 100;
  return ((value - cost) / value) * 100;
};

export const calculateFutureValue = (monthlyInvestment: number, annualRate: number, years: number): number => {
  const monthlyRate = annualRate / 100 / 12;
  const months = years * 12;
  
  if (monthlyRate === 0) {
    return monthlyInvestment * months;
  }

  const futureValue = monthlyInvestment * ( (Math.pow(1 + monthlyRate, months) - 1) / monthlyRate );
  return futureValue;
};
